export default __webpack_public_path__ + "static/7-d02b49e008fb44fb4300772bb7995cb5.jpg";